import React, { PureComponent } from 'react'
/** @jsx jsx */
import { jsx, css, Global } from '@emotion/core'
import { Button } from '@components/Button'
import { AccordionNavItem } from './AccordionNavItem'
import {
  AccordionNavWrapper,
  ButtonsWrapper,
  getMyQuoteBtnStyles,
  lockStyles,
} from './AccordionNav.elements'

type Props = {
  navGroups: NavGroupType[]
  onItemSelect?: () => void
  onLogin: () => void
  onGetMyQuote?: () => void
  greenBtnText?: string
}

type State = {
  openedNavKey: string | null
}

export class AccordionNav extends PureComponent<Props, State> {
  state: State = {
    openedNavKey: this.props.navGroups[0].key
  }

  componentDidMount() {
    document.body.classList.add('lock')
  }

  componentWillUnmount() {
    document.body.classList.remove('lock')
  }

  handleToggle = (groupKey: string) => {
    this.setState(prevState => ({
      openedNavKey: prevState.openedNavKey === groupKey ? null : groupKey
    }))
  }

  render() {
    const {
      navGroups,
      onItemSelect,
      onLogin,
      onGetMyQuote,
      greenBtnText,
    } = this.props
    const { openedNavKey } = this.state

    return (
      <AccordionNavWrapper>
        <Global styles={lockStyles} />

        {navGroups.map(group => (
          <AccordionNavItem
            key={group.key}
            isOpen={openedNavKey === group.key}
            navGroup={group}
            onItemSelect={onItemSelect}
            onToggle={this.handleToggle}
          />
        ))}

        <ButtonsWrapper>
          {onGetMyQuote && (
            <Button
              variant="green"
              onClick={onGetMyQuote}
              css={getMyQuoteBtnStyles}
            >
              {greenBtnText || 'Get My Quote'}
            </Button>
          )}
          <Button
            variant="green-outlined"
            onClick={onLogin}
          >
            Login
          </Button>
        </ButtonsWrapper>
      </AccordionNavWrapper>
    )
  }
}
